import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

// Components
import Layout from './components/Layout';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Project from './pages/Project';
import User from './pages/User';
import WebHooks from './pages/WebHooks';
import Devices from './pages/Devices';
import Account from './pages/Account';
import Zone from './pages/Zone';
import { useStateValue } from './ContextApi/StateProvider';
import EditOrganization from './pages/EditOrganization';

const App = () => {
  const [{ user }, dispatch] = useStateValue();
  return (
    <Router>
      <Layout>
        <Switch>
          <Route exact path="/">
            {user ? <Dashboard /> : <Login />}
          </Route>
          <Route exact path="/dashboard">
            <Dashboard />
          </Route>
          <Route exact path="/organization">
            <EditOrganization/>
          </Route>
          <Route exact path="/zone">
            <Zone />
          </Route>
          <Route exact path="/projects">
            <Project />
          </Route>
          <Route exact path="/users">
            <User />
          </Route>
          <Route exact path="/inventory">
            <Devices />
          </Route>
          <Route exact path="/webhooks">
            <WebHooks />
          </Route>
          <Route exact path="/account">
            <Account />
          </Route>
        </Switch>
      </Layout>
    </Router>
  );
};

export default App;
